import {
  Component,
  input,
  output,
} from '@angular/core';
import { LiteralService } from 'src/app/services';
import { images } from 'src/images';

@Component({
  selector: 'app-floating-button',
  templateUrl: './floating-button.component.html',
  styleUrl: './floating-button.component.scss',
  standalone: false,
})
export class FloatingButtonComponent {
  readonly generalOption = input<any>([]);
  readonly disabled = input<boolean>(false);
  readonly options = input<any>([]);
  readonly animatedButton = input(false);
  readonly forceOpen = input(false);
  readonly action = output<any>();
  readonly close = output();
  public images = images;

  constructor(public literalService: LiteralService) {}

  emitEvent(option?: any) {
    this.action.emit(option || undefined);
  }
}
